import { Box, TextField, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import ImageUpload from "./ImageUpload";

export const createEmptyAdditionalImage = () => ({
  file: null,
  public_id: "",
  url: "",
  image_alt_text: "",
});

const AdditionalImagesUpload = ({
  images,
  setImages,
  dimension = "Size: (400 : 300)",
  textFieldSx,
}) => {
  const item = images[0] ?? createEmptyAdditionalImage();

  const updateItem = (updates) => {
    setImages([{ ...item, ...updates }]);
  };

  return (
    <Box>
      <Typography
        variant="medium"
        color="text.main"
        sx={{ fontWeight: 500, mb: 2 }}
      >
        Additional Images
      </Typography>

      <Box
        sx={{
          p: 2,
          border: "1px solid #EAECF1",
          borderRadius: "12px",
        }}
      >
        <Grid2 container spacing={2} alignItems="flex-start">
          <Grid2 size={{ xs: 12, md: item.url ? 8 : 12 }}>
            <ImageUpload
              file={item.file}
              setFile={(file) => updateItem({ file })}
              dimension={dimension}
            />
          </Grid2>
          {item.url && (
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Current Image
              </Typography>
              <Box
                component="img"
                src={item.url}
                alt={item.image_alt_text || "Additional"}
                sx={{
                  width: "100%",
                  maxHeight: 160,
                  objectFit: "contain",
                  borderRadius: "8px",
                  border: "1px solid #EAECF1",
                }}
              />
            </Grid2>
          )}
          <Grid2 size={12}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Image Alt Text
            </Typography>
            <TextField
              size="small"
              fullWidth
              id="additional_image_alt_text"
              placeholder="Image Alt Text"
              variant="outlined"
              sx={textFieldSx}
              value={item.image_alt_text || ""}
              onChange={(e) => updateItem({ image_alt_text: e.target.value })}
            />
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
};

export const formatAdditionalImagesForSubmit = async (images, fileToBase64) => {
  return Promise.all(
    images
      .filter((item) => item?.file instanceof File || item?.url)
      .map(async (item) => {
        const image_alt_text = (item.image_alt_text || "").trim();

        if (item.file instanceof File) {
          const uploaded = await fileToBase64(item.file);
          return {
            ...uploaded,
            image_alt_text,
          };
        }

        return {
          public_id: item.public_id || "",
          url: item.url || "",
          image_alt_text,
        };
      })
  );
};

export const mapAdditionalImagesFromApi = (images = []) =>
  images.map((img) => ({
    file: null,
    public_id: img?.public_id || "",
    url: img?.url || "",
    image_alt_text: img?.image_alt_text || "",
  }));

export default AdditionalImagesUpload;
